import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Index from '@/components/Index'
import PrivacyStatement from '@/components/PrivacyStatement'

Vue.use(Router)

export default new Router({
  // mode: 'history', // 添加这一行，启用 history 模式
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path:'/PrivacyStatement',
      name:'PrivacyStatement',
      component:PrivacyStatement
    },
    // 添加一个捕获所有未匹配路由的规则，并重定向到首页
    // {
    //   path: '*',
    //   redirect: '/'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js